import styled, { css } from 'styled-components';
import { type StatusPillTone } from './StatusPill.constants';

const TONE_COLORS: Record<
  StatusPillTone,
  (theme: { colors?: Record<string, string | undefined> }) => {
    bg: string;
    fg: string;
  }
> = {
  neutral: ({ colors = {} }) => ({
    bg: colors.surfaceContainerHigh ?? '#292932',
    fg: colors.onSurfaceVariant ?? '#C7C4D7',
  }),
  success: ({ colors = {} }) => {
    const fg = colors.success ?? '#8CD88C';
    return { bg: `color-mix(in oklch, ${fg} 14%, transparent)`, fg };
  },
  caution: ({ colors = {} }) => {
    const fg = colors.caution ?? '#FFDF9E';
    return { bg: `color-mix(in oklch, ${fg} 14%, transparent)`, fg };
  },
  error: ({ colors = {} }) => {
    const fg = colors.error ?? '#FFB4AB';
    return { bg: `color-mix(in oklch, ${fg} 14%, transparent)`, fg };
  },
  info: ({ colors = {} }) => {
    const fg = colors.primary ?? '#C1C1FF';
    return { bg: `color-mix(in oklch, ${fg} 14%, transparent)`, fg };
  },
};

interface RootProps {
  $tone: StatusPillTone;
}

export const Root = styled.span<RootProps>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: ${({ theme: { borderRadius = {} } }) => borderRadius.full ?? '100px'};
  font-size: 11px;
  font-weight: 500;
  vertical-align: middle;

  ${({ $tone, theme }) => {
    const palette =
      TONE_COLORS[$tone]?.(theme) ?? TONE_COLORS.neutral(theme);
    return css`
      background: ${palette.bg};
      color: ${palette.fg};
    `;
  }}

  & > svg,
  & > .material-symbols-rounded {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
`;

export const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
`;
